import { Row as AntRow, Col as AntCol, RowProps, ColProps } from 'antd';

export const Row = AntRow;
export const Col = AntCol;

export type { RowProps, ColProps };
